import { getMapaRotas } from "@/services/api/rotas";
import { useQuery } from "@tanstack/react-query";
import { useWebgate } from "@xvia/webgate-connect";
export const useGetMapaRotas = (municipioPartida, municipioDestino, empresaId, diaSemana) => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: [
            "mapa-rotas",
            municipioPartida,
            municipioDestino,
            empresaId,
            diaSemana,
        ],
        queryFn: () => getMapaRotas(municipioPartida, municipioDestino, empresaId, diaSemana, accessToken),
        enabled: true,
        refetchOnWindowFocus: true,
    });
};
